import { forwardRef, useId } from "react";
import type { IconsaxProps } from "./Iconsax.types.js";

export const OpenMailBold = forwardRef<HTMLDivElement, IconsaxProps>(({ size = 24, color = "currentColor", ...rest }, ref) => {
    const clipId = useId();
    return (
        <div ref={ref} {...rest} style={{ display: "flex", width: "fit-content", alignItems: "center", justifyContent: "center", ...rest.style }}>
            <svg width={size} height={size} viewBox="0 0 24 24" fill={color} xmlns="http://www.w3.org/2000/svg">
                <g clipPath={`url(#${clipId})`}>
                    <path
                        d="M22 10.4398V10.8698C22 11.5698 21.63 12.2198 21.03 12.5798L13.54 17.0698C12.59 17.6398 11.41 17.6398 10.46 17.0698L2.97 12.5798C2.37 12.2198 2 11.5698 2 10.8698V10.4398C2 9.52985 2.41 8.66984 3.13 8.09984L10.13 2.49984C11.22 1.61984 12.78 1.61984 13.87 2.49984L20.87 8.09984C21.59 8.66984 22 9.52985 22 10.4398Z"
                        fill="white"
                        style={{ fill: "var(--fillg)" }}
                    />
                    <path
                        d="M20.48 14.6402C21.15 14.2402 22 14.7202 22 15.5002V19.0002C22 20.6602 20.66 22.0002 19 22.0002H5C3.34 22.0002 2 20.6602 2 19.0002V15.5002C2 14.7202 2.85 14.2402 3.52 14.6402L9.69 18.3602C10.4 18.7802 11.2 19.0002 12 19.0002C12.8 19.0002 13.6 18.7802 14.31 18.3602L20.48 14.6402Z"
                        fill="white"
                        style={{ fill: "var(--fillg)" }}
                    />
                </g>
                <defs>
                    <clipPath id={clipId}>
                        <rect width="24" height="24" fill="white" />
                    </clipPath>
                </defs>
            </svg>
        </div>
    );
});
